import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../data/translations';

const AboutSection = () => {
  const { language } = useLanguage();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Get the language-specific image
  const aboutImage = translations.about.image[language] || translations.about.image.en;

  return (
    <section
      id="who-is-nimny"
      ref={sectionRef}
      className="relative py-10 md:py-20 overflow-hidden"
    >
      {/* Transparent - stars show through */}

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6">
        {/* NO section title above card - title is inside the card image */}
        
        {/* Language-specific card */}
        <div className={`transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="relative max-w-full md:max-w-2xl lg:max-w-3xl mx-auto">
            {/* Card with subtle warm border and increased padding effect */}
            <div className="relative rounded-xl md:rounded-2xl overflow-hidden border border-amber-200/15 shadow-xl p-1 md:p-2 bg-[#f5ebe0]/5">
              <img 
                src={aboutImage}
                alt="Who is Nimny"
                className="w-full h-auto rounded-lg md:rounded-xl"
                loading="lazy"
                width="800"
                height="600"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
